import React from 'react';
import { NoAccountIcon } from '../../../components';
import { LinkTokenErrorScreen } from './LinkTokenErrorScreen';

/**
 * 招待リンクがすでに登録・処理済みだった場合に表示するフルページ画面。
 * デイサービス側でのアカウント再発行を案内する。
 */
export const AlreadyRegistered: React.FC = () => {
  return (
    <LinkTokenErrorScreen
      icon={<NoAccountIcon />}
      title="すでに登録済みのアカウントです"
      description={'恐れ入りますが、\nデイサービスからアカウントを\n再度発行いただくようお願いします。'}
    />
  );
};

export default AlreadyRegistered;
